
import './App.css';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import Home from './pages/Home';
import Map from './pages/Map'
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ReactGA from 'react-ga'
import { useEffect } from 'react';

const TRACKING_ID = "G-J6TF3MH409"
ReactGA.initialize(TRACKING_ID)

function App() {

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search)
  }, []);

  return (
    <BrowserRouter basename='/ODT20738'>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Map" element={<Map />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
